var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0117,
    cy: 31,
    r: 30.5,
    fill: "#F47920",
    stroke: "#F47920"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.5405 31.8363L25.5305 42.8513C25.3802 42.9425 25.2085 42.9925 25.0327 42.9962C24.8569 43 24.6832 42.9573 24.5292 42.8724C24.3752 42.7876 24.2463 42.6637 24.1554 42.5132C24.0645 42.3627 24.015 42.1908 24.0117 42.015V19.985C24.015 19.8092 24.0645 19.6374 24.1554 19.4869C24.2463 19.3363 24.3752 19.2124 24.5292 19.1276C24.6832 19.0428 24.8569 19.0001 25.0327 19.0038C25.2085 19.0075 25.3802 19.0575 25.5305 19.1488L43.5405 30.1638C43.6843 30.2509 43.8033 30.3736 43.8859 30.5201C43.9684 30.6666 44.0118 30.8319 44.0118 31C44.0118 31.1682 43.9684 31.3335 43.8859 31.48C43.8033 31.6265 43.6843 31.7492 43.5405 31.8363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0617 29.3113L26.0517 18.2938C25.7481 18.1078 25.4003 18.0063 25.0443 17.9997C24.6883 17.9931 24.337 18.0817 24.0267 18.2563C23.7194 18.4281 23.4633 18.6787 23.2849 18.9824C23.1065 19.286 23.0122 19.6316 23.0117 19.9838V42.0163C23.014 42.5445 23.226 43.0502 23.601 43.4222C23.9761 43.7942 24.4835 44.002 25.0117 44C25.3804 43.9999 25.7419 43.8982 26.0567 43.7063L44.0617 32.6888C44.3511 32.5124 44.5903 32.2645 44.7563 31.969C44.9223 31.6734 45.0094 31.3402 45.0094 31.0013C45.0094 30.6623 44.9223 30.3291 44.7563 30.0336C44.5903 29.738 44.3511 29.4902 44.0617 29.3138V29.3113ZM25.0117 41.9925V20L42.9905 31L25.0117 41.9925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOrange);
export default __webpack_public_path__ + "static/media/playOrange.ec909080bd53a76c1ce995598edfa90c.svg";
export { ForwardRef as ReactComponent };